import React, { useEffect, useState } from 'react';
import axios from 'axios';

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('adeeb-token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [toast, setToast] = useState('');
  const [me, setMe] = useState(null);

  const ping = (m) => { setToast(m); setTimeout(() => setToast(''), 1800); };

  const load = async (search = '') => {
    setLoading(true);
    setErr('');
    try {
      const { data } = await axios.get('/api/admin/users', {
        headers: authHeaders(),
        params: search ? { q: search } : {},
        timeout: 10000,
      });
      setUsers(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e?.response?.data?.message || 'Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios.get('/api/auth/me', { headers: authHeaders() }).then(({ data }) => setMe(data?.user)).catch(() => {});
    load('');
  }, []);

  // Debounce search
  useEffect(() => {
    const t = setTimeout(() => load(q.trim()), 240);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  const setRole = async (u, role) => {
    try {
      const { data } = await axios.put(`/api/admin/users/${u._id}/role`, { role }, { headers: authHeaders() });
      setUsers((list) => list.map((x) => (x._id === u._id ? data : x)));
      ping(`${u.email}: now ${role}`);
    } catch (e) {
      setErr(e?.response?.data?.message || 'Update failed');
    }
  };

  const onDelete = async (u) => {
    if (!window.confirm(`Delete ${u.email}? This also removes their favourites, playlist, progress and ratings.`)) return;
    try {
      await axios.delete(`/api/admin/users/${u._id}`, { headers: authHeaders() });
      setUsers((list) => list.filter((x) => x._id !== u._id));
      ping(`Deleted ${u.email}`);
    } catch (e) {
      setErr(e?.response?.data?.message || 'Delete failed');
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <h1 className="admin-page-title">Users</h1>
        <p className="admin-page-sub">{users.length} match · search by name or email.</p>
      </header>

      <div className="admin-toolbar">
        <input
          className="admin-input admin-search"
          placeholder="Search by name or email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {err && <div className="admin-toast admin-toast-error">{err}</div>}
      {toast && <div className="admin-toast">{toast}</div>}

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Provider</th>
              <th>Verified</th>
              <th>Role</th>
              <th>Joined</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 30 }}>Loading…</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 30, opacity: 0.7 }}>No users match.</td></tr>
            ) : users.map((u) => {
              const isMe = me && me._id === u._id;
              return (
                <tr key={u._id}>
                  <td><strong style={{ color: 'var(--admin-fg-strong)' }}>{u.name || '—'}</strong>{isMe && <span className="admin-tag admin-tag-admin" style={{ marginLeft: 8 }}>you</span>}</td>
                  <td>{u.email}</td>
                  <td>{u.provider || 'local'}</td>
                  <td>{u.emailVerified ? 'yes' : 'no'}</td>
                  <td>{u.role === 'admin' ? <span className="admin-tag admin-tag-admin">admin</span> : <span className="admin-tag admin-tag-user">user</span>}</td>
                  <td style={{ fontSize: '0.82rem', opacity: 0.75 }}>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '—'}</td>
                  <td>
                    <div className="admin-row-actions">
                      {u.role === 'admin' ? (
                        <button type="button" className="admin-btn admin-btn-ghost admin-btn-sm" disabled={isMe} onClick={() => setRole(u, 'user')}>Revoke admin</button>
                      ) : (
                        <button type="button" className="admin-btn admin-btn-sm" onClick={() => setRole(u, 'admin')}>Make admin</button>
                      )}
                      <button type="button" className="admin-btn admin-btn-danger admin-btn-sm" disabled={isMe} onClick={() => onDelete(u)}>Delete</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
